/**
 * The distance from the horizontal start edge in pixels.
 * @type {number}
 */
export const scrollAreaOverflowXStart = '--scroll-area-overflow-x-start';
/**
 * The distance from the horizontal end edge in pixels.
 * @type {number}
 */
export const scrollAreaOverflowXEnd = '--scroll-area-overflow-x-end';
/**
 * The distance from the vertical start edge in pixels.
 * @type {number}
 */
export const scrollAreaOverflowYStart = '--scroll-area-overflow-y-start';
/**
 * The distance from the vertical end edge in pixels.
 * @type {number}
 */
export const scrollAreaOverflowYEnd = '--scroll-area-overflow-y-end';
